module.exports = __webpack_public_path__ + "static/stylish-a39d36a97802a18578497a4ab446e633.png";